module.exports = __webpack_public_path__ + "static/media/1.ae7a3782.jpg";